import { OnInit, AfterViewInit, Renderer2, ChangeDetectorRef, AfterContentChecked, OnDestroy } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var CharacterCounterComponent = /** @class */ (function () {
    function CharacterCounterComponent(renderer, ref) {
        this.renderer = renderer;
        this.ref = ref;
        this.ngUnsubscribe = new Subject();
        this.display = 'block';
        this.mode = 'count';
    }
    Object.defineProperty(CharacterCounterComponent.prototype, "remainingCount", {
        get: function () {
            return this.max - this.count;
        },
        enumerable: true,
        configurable: true
    });
    CharacterCounterComponent.prototype.ngOnInit = function () {
        this.count = 0;
        this.max = this.field.maxLength || 0;
    };
    CharacterCounterComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.input$ = fromEvent(this.field, 'input');
        this.input$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.updateCount();
        });
    };
    CharacterCounterComponent.prototype.ngAfterContentChecked = function () {
        this.updateCount();
    };
    CharacterCounterComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    CharacterCounterComponent.prototype.updateCount = function () {
        var updateCount = this.field.value.length;
        // Manual "dirty" check
        if (this.count !== updateCount) {
            this.count = updateCount;
            this.ref.markForCheck();
        }
    };
    return CharacterCounterComponent;
}());
export { CharacterCounterComponent };
